import React from 'react';
import { withTranslation } from 'react-i18next';

class AddCustomAttr extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            tableProps:this.props.tableProps?this.props.tableProps: [],
            showFieldDropdown:false,
            selshowFieldId:this.props.tableProps.field_type_id,
            selshowFieldVal:this.props.tableProps.selshowFieldVal,
            values: this.props.tableProps.values,
            showCategory:false,
            oldCatId:this.props.tableProps.cat_id,
            selCat:this.props.tableProps.categoryName,
            selCatId:this.props.tableProps.cat_id,
            attributeName: this.props.tableProps.name,
            addClcik: this.props.tableProps.id != '' ? true : false,
            showEditPermission:false,
            VisibilityPermission:false,
            selEdit:this.props.tableProps.selEdit,
            selEditId:this.props.tableProps.selEditId,
            selVisibId:this.props.tableProps.selVisibId,
            selVisib:this.props.tableProps.selVisib,
            errorMsgName: false,
            errorMsgNameText: 'Please enter field name',
            errorMsgType: false,
            errorMsgTypeText: 'Please enter field type',
            errorMsgCategory: false,
            errorMsgCategoryText: 'Please select category',
            errorMsgEdit: false,
            errorMsgEditText: 'Please select edit permission',
            errorMsgView: false,
            errorMsgViewText: 'Please select view permission',
            errorMsgDropDownType:false,
            errorMsgDropDownText: 'Please enter drop down text',
            editPermission:this.props.tableProps.editPermission,
	        viewPermission:this.props.tableProps.viewPermission,
	        id:this.props.tableProps.id,
	        type:this.props.tableProps.type,
	        validationError:false,
        };
        this.handleClick = this.handleClick.bind(this);
        this.selFieldType = this.selFieldType.bind(this);
        this.onChangeAttr = this.onChangeAttr.bind(this);
        this.clickfiledDropdown = this.clickfiledDropdown.bind(this);
        this.createUI = this.createUI.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.removeClick = this.removeClick.bind(this);
        this.addClick = this.addClick.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.clickCategory = this.clickCategory.bind(this);
        this.clickEditPermission = this.clickEditPermission.bind(this);
        this.clickVisibilityPermission = this.clickVisibilityPermission.bind(this);
        this.selCategory = this.selCategory.bind(this);
        this.selEditPermission = this.selEditPermission.bind(this);
        this.selVisibilityPermission = this.selVisibilityPermission.bind(this);
    }

    componentDidMount(){
        window.addEventListener("click", this.handleClick, true);
    }

    handleClick(e){
	    if (!$('.popupClick').is(e.target)
	        && $('.popupClick').has(e.target).length === 0) {
	        this.setState({ 
	            showFieldDropdown:false,
	            showCategory:false,
	            showEditPermission:false,
	            VisibilityPermission:false,
	        });
	    }
    }

    selFieldType(selId,selVal){
    	let _this = this;
        setTimeout(function(){
		 	_this.setState({
            	selshowFieldId:selId,
	            selshowFieldVal:selVal,
	            showFieldDropdown:false,
	            showCategory:false,
            })
		}, 5); 
    }

    onChangeAttr(e,attr){
    	let errorMsgName = this.state.errorMsgName;
    	if(attr == 'attributeName'){
    		errorMsgName = false;
    	}
        this.setState({
            [attr]:e.target.value,
            errorMsgName:errorMsgName
        });
    }

    clickfiledDropdown(){
    	this.setState({ 
            showFieldDropdown:true,
    		showEditPermission:false,
    		VisibilityPermission:false,
            errorMsgType:false,
            showCategory:false,
        });
    }

    createUI(){
    	if(this.state.values != undefined){
    		return this.state.values.map((el, i) => 
		     	( i != 0 ) ?  
		         <div key={i}> <div className="rowCound">{i+1} .</div>
		    	     <input autoFocus={true}  type="text" value={el||''} onChange={this.handleChange.bind(this, i)}   className="fieldDropdown input newDropDownField" />
	    	         <div  value='remove' onClick={this.removeClick.bind(this, i)} className="addRemoveButton">-</div>
		         </div> 
		         :''         
		     )
    	}
	     
    }

    handleChange(i, event) {
    	let _this = this;
    	let noData = false;
    	let errorMsgDropDownType;
	    let values = [...this.state.values];
	    values[i] = event.target.value;
	    setTimeout(function(){
		 	_this.setState({ values });
		    _this.state.values.map((item) => {
	    		if(!item){
	    			noData = true;
	    		}
	    	})
	    	if(noData){
	    		errorMsgDropDownType =  true;
	    	}else{
	    		errorMsgDropDownType = false;
	    	}
	    	_this.setState({
	    		errorMsgDropDownType: errorMsgDropDownType,
	    	})
		}, 5);  
    }

    removeClick(i){
	     let values = [...this.state.values];
	     values.splice(i,1);
	     this.setState({ values });
    }

    addClick(){
    	let noData = false;
    	this.state.values.map((item) => {
    		if(!item){
    			noData = true;
    		}
    	})
    	if(!noData){
	    	this.setState(function (prevState) {
	    		if(prevState.values[prevState.values.length-1]){
	    			return {
		            	values: [...prevState.values, '']
		        	};
	    		}
		    });
		}
	    //this.setState(prevState => ({ values: [...prevState.values, '']}));
	    this.setState({
	    	addClcik:true,
	    })
    }

  	handleSubmit(event) {
	    let validationError 		= false;
	    let errorMsgName 			= false;//this.state.errorMsgName;
	    let errorMsgType   			= false;//this.state.errorMsgType;
	    let errorMsgDropDownType 	= false;//this.state.errorMsgDropDownType;
	    let errorMsgEdit 			= false;//this.state.errorMsgEdit;
	    let errorMsgView 			= false;//this.state.errorMsgView;
	    if(this.state.attributeName == '' || this.state.attributeName == undefined){
	    	validationError = true;
	    	this.setState({
	    		errorMsgName: true,
	    		validationError:true,
	    	})
	    }
	    if(this.state.selshowFieldId == '' || this.state.selshowFieldId == undefined){
	    	validationError = true;
	    	this.setState({
	    		errorMsgType: true,
	    		validationError:true,
	    	})
	    }
	    if((this.state.selshowFieldId == 3 || this.state.selshowFieldId == 4)){
	    	let noData = false;
	    	if(this.state.values.length == 0){
	    		noData = true;
	    	}
	    	this.state.values.map((item) => {
	    		if(!item){
	    			noData = true;
	    		}
	    	})
	    	if(noData){
	    		validationError = true;
	    		this.setState({
		    		errorMsgDropDownType: true,
		    		validationError:true,
		    	})
	    	}
	    }
	    if((this.state.selEditId == '' || this.state.selEditId == undefined) && this.state.type == 1 ){
	    	validationError = true;
	    	this.setState({
	    		validationError:true,
	    		errorMsgEdit: true,
	    	})
	    }
	    if((this.state.selVisibId == '' || this.state.selEditId == undefined) && this.state.type == 1){
	    	validationError = true;
	    	this.setState({
	    		errorMsgView: true,
	    		validationError: true,
	    	})
	    }
	    if(!validationError){
	    	if(typeof this.props.tableProps.buttons.save.callBack === 'function'){
		    	this.props.tableProps.buttons.save.callBack(this.state);
	        }
	    }
		
	    
    }

    clickCategory(){
    	this.setState({
    		showCategory:true,
    		showEditPermission:false,
    		VisibilityPermission:false,
    		showFieldDropdown:false,
    	})
    }

    clickEditPermission(){
    	this.setState({
    		showCategory:false,
    		showEditPermission: !this.state.showEditPermission,
    		VisibilityPermission:false,
    		showFieldDropdown:false,
    	})
    }

    clickVisibilityPermission(){
    	this.setState({
    		showCategory:false,
    		showEditPermission:false,
    		showFieldDropdown:false,
    		VisibilityPermission:!this.state.VisibilityPermission,
    	})
    }

    selCategory(id,sel){
    	let _this = this;
		setTimeout(function(){
		 	_this.setState({
            	selCat:sel,
	            selCatId:id,
	    		showCategory:false,
            })
		}, 5);   
    }

    selEditPermission(id,sel){
    	let newElem = this.state.selEdit.length > 0 ? ","+sel : sel;
		let _this = this;
		setTimeout(function(){
		 	_this.setState({
            	showEditPermission:true
            })
		}, 5);     

		var idx = $.inArray( id,_this.state.selEditId);
		if (idx == -1) {
		  	_this.state.selEditId.push(id);
		} else {
		  	_this.state.selEditId.splice(idx, 1);
		}
		var idStr = $.inArray( sel,_this.state.selEdit);
		if (idStr == -1) {
		  	_this.state.selEdit.push(sel);
		} else {
		  	_this.state.selEdit.splice(idStr, 1);
		}
		_this.state.editPermission.map(el => {
			if(el.role_id == id){
				el.checkItem = !el.checkItem;
			}
		})           
    }

    selVisibilityPermission(i,id,sel){	    
    	let newElem = this.state.selVisib.length > 0 ? ","+sel : sel;
    	let _this = this;
		setTimeout(function(){
		 _this.setState({
                VisibilityPermission:true
            })
		}, 5);   

		var idx = $.inArray( id,_this.state.selVisibId);
		if (idx == -1) {
		 	_this.state.selVisibId.push(id);
		} else {
		  	_this.state.selVisibId.splice(idx, 1);
		}
		var idStr = $.inArray( sel,_this.state.selVisib);
		if (idStr == -1) {
		  	_this.state.selVisib.push(sel);
		} else {
		  	_this.state.selVisib.splice(idStr, 1);
		}
		_this.state.viewPermission.map(el => {
			if(el.role_id == id){
				el.checkItem = !el.checkItem;
			}
		})
    }

    render(){
		const { t } = this.props;
		let tableProps = this.state.tableProps;
		let category = tableProps.category;
		return(
				<div>
					<div className="AddCustomAttrWrap">
						<div className="addWsCustmHead">
	                        <div className="popupWrap">
	                            <div className="headLable">{tableProps.title}</div>
	                            <div className="headClose" onClick ={this.props.cancel}> <img className="closeX" src={wbConfig.baseUrl + "/images/ai-v1-assets/x.png"}/></div>
	                        </div>
	                    </div>


						<div className="AddWsCustmBoay ">  
	                        <div className="popupWrap">
	                            <div className="col">
	                                <div className="lable">{t("Field Name")}</div>
	                                <div className="content">
	                                	<input  className="input categoryName addMargin"  type="text"  name="attributeName"  value={this.state.attributeName} onChange={(e) => this.onChangeAttr(e,'attributeName')} tabIndex="1" />
	                                	{
	                                		this.state.errorMsgName && 
	                                			<span className="errorText">{this.state.errorMsgNameText}</span>
	                                	}
	                                </div>
	                            </div>
	                            <div className="col">
	                                <div className="lable">{t("Field Type")}</div>
	                                <div className="content">
	                                    <div  className="fieldDropdown popupClick addMargin" onClick={(e) => this.clickfiledDropdown()} id={this.state.selshowFieldId} tabIndex="2">
	                                    {this.state.selshowFieldVal}
	                                    {
	                                    	this.state.showFieldDropdown && 
										   	<FieldTypeSelect  selFieldType={this.selFieldType} t={t}/>
	                                    }
										</div>
										{
											this.state.errorMsgType && 
												<span className="errorText">{this.state.errorMsgTypeText}</span>
										}
	                                </div>

	                            </div>
	                        </div>
	                        { (this.state.selshowFieldId == 3 || this.state.selshowFieldId == 4) &&
		                        <div className="popupWrap">
		                            <div className="col">
		                                <div className="lable dropdownLable">{t("Dropdown labels")}</div>
		                                <div className="content addedField">
		                                	<div className="rowCound">1 .</div>
		                                	<input autoFocus={true}  className="fieldDropdown input newDropDownField "  type="text" value={(this.state.values != '' && undefined !== this.state.values ) ? this.state.values[0] : ''} name={(this.state.values != ''  && undefined !== this.state.values ) ? this.state.values[0] : ''}  onChange={this.handleChange.bind(this, 0)} />
		                                	<div onClick={(e)=> this.addClick(e)} className="addRemoveButton">+</div>
		                                	{ this.state.addClcik && this.createUI() }
		                                	{
			                                	this.state.errorMsgDropDownType &&
			                                		<span className="errorText">{this.state.errorMsgDropDownText}</span>
			                                }
		                                </div>
		                                
		                            </div>
		                        </div>
	                    	}


	                    	<div className="popupWrap">
	                            <div className="col">
	                                <div className="lable dropdownLable">{t("Category")}</div>
	                                <div className="content addedField" >
	                                	<div  className="fieldDropdown popupClick addMargin " onClick={(e) => this.clickCategory()} id={this.state.selCatId} tabIndex="3">
	                                		<div className="truncateText">{(this.state.selCatId == -1 || this.state.selCatId == null)  ? "N/A" : this.state.selCat}</div> 
	                                		{ this.state.showCategory  &&
	                                			<ListCategory selCategory={this.selCategory} category={category}/>
	                                		}
	                                	</div>
	                                	{
		                                	this.state.errorMsgCategory &&
		                                		<span className="errorText">{this.state.errorMsgCategoryText}</span>
		                                }
	                                </div>
	                            </div>
	                        </div>
	                        { this.state.editPermission &&
		                        <div className="popupWrap">
		                            <div className="col">
		                                <div className="lable dropdownLable">{t("Edit Permissions")}</div>
		                                <div className="content addedField">
		                                	<div  className="fieldDropdown popupClick addMargin" onClick={(e) => this.clickEditPermission()} id={this.state.selEditId} tabIndex="4">{this.state.selEdit.length >  0 ? this.state.selEdit.toString() : 'Permissions' }
		                                		{ this.state.showEditPermission && 
		                                			<EditPermission selEditPermission={this.selEditPermission} editPermission={this.state.editPermission} />
		                                		}
		                                	</div>
		                                	{
		                                		this.state.errorMsgEdit &&
		                                			<span className="errorText">{this.state.errorMsgEditText}</span>
		                                	}
		                                </div>
		                            </div>
		                        </div>
	                    	}

	                        { this.state.viewPermission && 
	                        	<div className="popupWrap" style={{padding:'15px 25px 35px 25px'}}>
    	                            <div className="col">
    	                                <div className="lable dropdownLable">{t("Visibility Permissions")}</div>
    	                                <div className="content addedField">
    	                                	<div  className="fieldDropdown popupClick addMargin" onClick={(e) => this.clickVisibilityPermission()} id={this.state.selVisibId} tabIndex="5">{ this.state.selVisib.length > 0 ? this.state.selVisib.toString() : 'Permissions' }
    	                                		{ this.state.VisibilityPermission && 
    	                                			<VisibilityPermission selVisibilityPermission={this.selVisibilityPermission} viewPermission={this.state.viewPermission}/>
    	                                		}
    	                                	</div>
    	                                	{
    	                                		this.state.errorMsgView &&
    	                                			<span className="errorText">{this.state.errorMsgViewText}</span>
    	                                	}
    	                                </div>
    	                            </div>
    	                        </div>
    	                    }

	                    </div>

						<div className="addCustmBtn ">
	                        <div className="btnSave" onClick={(e)=>this.handleSubmit()}>{tableProps.buttons.save.name}</div>
	                    </div>
					</div>
				</div>
			  );
	}
}
AddCustomAttr.defaultProps = {
    tableProps: [],
};

const FieldTypeSelect = (props) => {
	const { t } = props;
	return (
			<div className="typeSelectWrap">
				<div data-value="1" className="option" onClick={(e) =>props.selFieldType(1,'Text field')}>{t("Text field")}</div>
			    <div data-value="2" className="option" onClick={(e) =>props.selFieldType(2,'Text Area')}>{t("Text Area")}</div>
			    <div data-value="3" className="option" onClick={(e) =>props.selFieldType(3,'Dropdown List')}>{t("Dropdown List")}</div>
			    <div data-value="4" className="option" onClick={(e) =>props.selFieldType(4,'Multi-select Dropdown')}>{t("Multi-select Dropdown")}</div>
			</div>
		   )
}

class ListCategory extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            categoryes:[],
        };
    }
    
	render(){
		let category = this.props.category;
		return (
			<div className="typeSelectWrap verticalScroll">
				{
					category.map((item, index) => (
						<div key={item.id} data-value={item.id} className="option" onClick={(e) =>this.props.selCategory(item.id,item.name)}>
						{item.name}
					</div>
					))

				}
				
			</div>
		)
	}

}

class EditPermission extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            editPermission:this.props.editPermission
        };
        this.setValue = this.setValue.bind(this);
    }

    componentdidMount(){
		//call ajax and get editPermission ;
    }
    
	setValue(i,id,value){
		this.props.selEditPermission(id,value);
    }
    
	render(){
		let editPermission = this.props.editPermission;
		return (
			<div className="typeSelectWrap" style={{width:'100%' }}>
				{
					editPermission.map((row, index) => (
						<div className="option" data-value={row.role_id} onClick={(e) =>this.setValue(index,row.role_id,row.value)}>
						    <div className="grp-meeting-attendee-ckbox ">
			                    <input type="checkbox" id={row.role_id} className="grp-meeting-attendee-select" 
			                        checked={row.checkItem} value={row.role_id} data-check={row.checkItem}/>
			                    <label htmlFor={row.role_id}></label>
			                </div>
			                <div className="grp-meeting-user-det ">
			                    <div className="grp-meeting-user-team truncateText">
			                        {row.value}
			                    </div>
			                </div>
						</div>
					))
				}
			</div>
		)
	}
}

class VisibilityPermission extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            viewPermission:this.props.viewPermission
        };
        this.setValue = this.setValue.bind(this);
    }

    componentdidMount(){
		//call ajax and get categoryes ;
    }
    
	setValue(i,id,value){
		this.props.selVisibilityPermission(i,id,value);
    }
    
	render(){
		let viewPermission = this.props.viewPermission;
		return (
			<div className="typeSelectWrap" style={{width:'100%' }}>
			{
				viewPermission.map((row, index) => (
					<div className="option" data-value={row.role_id} onClick={(e) =>this.setValue(index,row.role_id,row.value)}>
					    <div className="grp-meeting-attendee-ckbox ">
		                    <input type="checkbox" id={row.role_id} className="grp-meeting-attendee-select" 
		                        checked={row.checkItem} value={row.role_id} data-check={row.checkItem}/>
		                    <label htmlFor={row.role_id}></label>
		                </div>
		                <div className="grp-meeting-user-det ">
		                    <div className="grp-meeting-user-team truncateText">
		                        {row.value}
		                    </div>
		                </div>
					</div>
				))
			}
			</div>
		)
	}
}


export default withTranslation()(AddCustomAttr);